export const DEFAULT_NAME = '余光管理系统';
